import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPBulkPaymentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/BulkPayment/BulkPaymentBrowser")
	}

	render() {
		return (
			<Activity 
				name="BulkPayment"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPBulkPayment"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPBulkPaymentActivity)
